import { Injectable, isDevMode } from '@angular/core';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { SatisfactionDaoService } from 'src/app/dao/satisfaction-dao-services/satisfaction-dao-service/satisfaction-dao.service';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { EMPTY } from 'rxjs';
import { UserService } from '../../user-service/user.service';

@Injectable({
  providedIn: 'root'
})
export class SatisfactionService {

  accessToken = 'SAT';
  private refreshSatisfactionsListener = new Subject();

  constructor(private userStorageService: UserStorageService,
              private userService: UserService,
              private satisfactionDaoService: SatisfactionDaoService) { }

  public getSatisfactionsList(datetimefrom, datetimeto) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.satisfactionDaoService.getSatisfactionsList(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), datetimefrom, datetimeto).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['data']['list'])
      );
    }
    return EMPTY;
  }

  public listenRefreshSatisfactions() {
    return this.refreshSatisfactionsListener.asObservable();
  }

  public refreshSatisfactions(from, to) {
    this.refreshSatisfactionsListener.next({ from, to });
  }

}
